(function () {
    "use strict";

    angular
        .module("app")
        .directive("basicMaterialSearchHelp", ["SearchFactory", basicMaterialSearchHelp]);

    function basicMaterialSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {                   

                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.basicMaterialName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }
                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.basicMaterialName === scope.displayValue) ) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.basicMaterialSearch(function (basicMaterial) {
                        scope.basicMaterialName = basicMaterial ? basicMaterial.BasicMaterialName : "";
                        scope.displayValue = scope.basicMaterialName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.displayValue = scope.basicMaterialName;
                scope.prevDisplayValue = scope.displayValue;

                scope.$watch("basicMaterialName", function (newValue) {
                    scope.displayValue = newValue;
                });

            },
            scope: { basicMaterialName: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&", isDirty: "=" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

